import React from "react";
import { Box, Button } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";

import FileUploadButton from "./FileUpload/FileUploadButton";
import { romanize } from "../../../../utils/helper";
import { DOCUMENTS, IS_DELETABLE, IS_EDITABLE, IS_INPUT_OPENED, LABEL, REQUIRED, _URL } from "../../../../constants/forms";

const Documents = (props: { fieldName: string; index: number }) => {
  const { fieldName, index } = props;
  const { values, touched, errors, setFieldValue } = useFormikContext<FormikValues>();

  const deleteInputGrid = (i: number) => {
    let val = [...values[fieldName]];
    if (val[index][DOCUMENTS].length > 0) {
      val[index][DOCUMENTS] = val[index][DOCUMENTS].filter(
        (field: any, index: any) => i !== index
      );
      setFieldValue(fieldName, val);
    }
  };

  const addInputFromGrid = () => {
    const prevData = [...values[fieldName][index].documents];
    let val = [...values[fieldName]];
    val[index][DOCUMENTS] = [
      ...prevData,
      {
        [LABEL]: "",
        [REQUIRED]: false,
        [_URL]: "",
        [IS_DELETABLE]: true,
        [IS_INPUT_OPENED]: true,
      },
    ];
    setFieldValue(fieldName, val);
  };

  const changeLabelToInput = (i: number) => {
    let val = [...values[fieldName]];
    if (val[index][DOCUMENTS][i][IS_EDITABLE] === false) {
      return;
    }

    val[index][DOCUMENTS][i][IS_INPUT_OPENED] =
      !val[index][DOCUMENTS][i][IS_INPUT_OPENED];

    setFieldValue(fieldName, val);
  };

  const changeLabelName = (
    e: React.ChangeEvent<HTMLInputElement>,
    i: number
  ) => {
    e.preventDefault();
    let val = [...values[fieldName]];
    val[index][DOCUMENTS][i][LABEL] = e.target.value;
    setFieldValue(fieldName, val);
    e.target.focus();
  };

  return (
    <Box className=" mg-b-0  mg-t-20 ">
      {values[fieldName][index][DOCUMENTS]?.length > 0 &&
        values[fieldName][index][DOCUMENTS]?.map((item: any, i: number) => (
        <Box key={`${index}-${i}`}>
          <Box
            className="d-flex align-items-center justify-content-start gap-sm mg-b-10 "
            
          >
            <label className="form-label">
              {" "}
              {romanize(i + 1)}
              {") "}
            </label>

            <Box
              className={`d-flex justify-content-between align-items-center gap-sm width-85`}
            >
              {!item?.[IS_INPUT_OPENED] ? (
                <label
                  className="form-label mg-b-0 font-size-14 width-60"
                  onClick={() => changeLabelToInput(i)}
                >
                  {item[LABEL]}
                  {item?.[REQUIRED] && <span className="error"> * </span>} :{" "}
                </label>
              ) : (
                <>
                  <input
                    type="text"
                    className="form-control width-50"
                    placeholder="Type document name"
                    value={item[LABEL]}
                    onBlur={() => changeLabelToInput(i)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      changeLabelName(e, i)
                    }
                  />
                </>
              )}

              <FileUploadButton
                showError={false}
                name={fieldName}
                gridName={_URL}
                index={i}
                parentIndex={index}
                label="Upload"
                className="mg-t-0"
                fileName='meeting.pdf'
              />
            </Box>

            {item[IS_DELETABLE] && (
              <button
                onClick={() => deleteInputGrid(i)}
                type={"button"}
                className={`btn btn-link text-danger`}
              >
                <i className={`icon-trash`}></i>
              </button>
            )}
            {/* <ErrorMessage
                name={fieldName}
                render={(msg) => (
                  <span className="text-danger font-size-sm">{msg}</span>
                )}
              /> */}
          </Box>
          {(touched as any)?.['projects']?.[index]?.documents && (errors as any)?.['projects']?.[index]?.documents && <span className="text-danger font-size-sm">{(errors as any)?.['projects']?.[index]?.documents[i]?.url }</span>}
        </Box>
        ))}
      <br />
      <Button
        variant={"text"}
        color={"error"}
        onClick={addInputFromGrid}
        type="button"
      >
        <AddCircleOutline className="mg-r-10" />
        Add Other if any
      </Button>
    </Box>
  );
};

export default Documents;
